document.addEventListener('DOMContentLoaded', function () {
    // 产品折扣复制
    $('body').on('click', '.code_text_copy', function () {
        navigator.clipboard.writeText($(this).siblings('.discount_content').find('.sale_codes').text());
        $(this).html(
            '<svg class="icon icon-check" viewBox="0 -65 434.67733 434"  xmlns="http://www.w3.org/2000/svg"><path d="m152.003906 304.34375c-5.460937 0-10.921875-2.089844-15.082031-6.25l-130.664063-130.667969c-8.34375-8.339843-8.34375-21.824219 0-30.164062 8.339844-8.339844 21.820313-8.339844 30.164063 0l115.582031 115.582031 246.253906-246.25c8.339844-8.339844 21.820313-8.339844 30.164063 0 8.339844 8.34375 8.339844 21.824219 0 30.167969l-261.332031 261.332031c-4.160156 4.160156-9.625 6.25-15.085938 6.25zm0 0"/></svg>'
        );
        let that = this
        var inter01 = setInterval(couponupdate, 3000);
        function couponupdate() {
            $(that).html('<span>Copy</span>');
            clearInterval(inter01);
        }
    });

    // stock文字提示
    $('body').on({
        mouseenter: function () {
            $(this).siblings('.eu-tips-boxs').show();
        },
        mouseleave: function () {
            $(this).siblings('.eu-tips-boxs').hide();
        }
    }, '.product-stock-status .eu-question');
})